import type { IInventoryAdapter } from './IInventoryAdapter'

const adapterRegistry = new Map<string, IInventoryAdapter>()

export const registerAdapter = (code: string, adapter: IInventoryAdapter): void => {
  adapterRegistry.set(code, adapter)
}

export const getAdapter = (code: string): IInventoryAdapter | undefined => {
  return adapterRegistry.get(code)
}

